import React from 'react';
import { Icon, Typography, Button, ButtonMenu, Scrollbar } from '@ann/web-components';
import { 
  UsersListContainerExternal, 
  UsersListContainerInternal, 
  UserItem, 
  UserInfo, 
  UserActions, 
  TitleDescriptionContainer, 
  TitleAndListContainer 
} from './ShareKnowledgeModal.styled';
import { NameInitialsAvatar } from 'react-name-initials-avatar';

const PendingUsersList = ({
  pendingUsers,
  privileges,
  onUpdatePermission,
  onRemove
}) => {
  if (pendingUsers.length === 0) return null;

  return (
    <TitleAndListContainer>
      <TitleDescriptionContainer>
        <Typography category="subtitle" size="small" weight="bold" color="subtitle">
          To be added
        </Typography>
        <Typography category="body" size="medium" weight="regular" color="body">
          You're about to add {pendingUsers.length} {pendingUsers.length === 1 ? 'user' : 'users'}
        </Typography>
      </TitleDescriptionContainer>

      <UsersListContainerExternal>
        <Scrollbar size="small">
          <UsersListContainerInternal>
            {pendingUsers.map((user) => (
              <UserItem key={user.grantee_uuid}>
                <UserInfo>
                  <NameInitialsAvatar
                    name={user.grantee_name}
                    bgColor="#2563eb"
                    textColor="#ffffff"
                    size="24px"
                    borderRadius="50%"
                    textWeight="bold"
                    textSize="12px"
                    borderColor="#ffffff"
                    borderStyle="solid"
                    borderWidth="2px"
                  />
                  <Typography
                    category="body"
                    size="medium"
                    weight="regular"
                    color="body"
                  >
                    {user.grantee_name} {user.grantee_email}
                  </Typography>
                </UserInfo>
                
                <UserActions>
                  <ButtonMenu
                    iconPosition="right"
                    label={user.privileges[0]?.privilege_name || 'Permission'}
                    menuPosition="bottom"
                    onChange={(value) => onUpdatePermission(user.grantee_uuid, value)}
                    size="medium"
                    pill={true}
                    type="secondary"
                    width="auto"
                    usePortal={true}
                    disableEffects={true}
                  >
                    <ButtonMenu.Menu>
                      {privileges.knowledgeBasePrivileges.map((privilege) => (
                        <ButtonMenu.Item
                          key={privilege.entityPrivilegeUuid}
                          label={privilege.privilegeName}
                          value={privilege.privilegeName}
                        >
                          {privilege.privilegeName}
                        </ButtonMenu.Item>
                      ))}
                    </ButtonMenu.Menu>
                  </ButtonMenu>
                  <Button
                    icon="close"
                    size="medium"
                    type="tertiary"
                    onClick={() => onRemove(user.grantee_uuid)}
                  />
                </UserActions>
              </UserItem>
            ))}
          </UsersListContainerInternal>
        </Scrollbar>
      </UsersListContainerExternal>
    </TitleAndListContainer>
  );
};

export default PendingUsersList;

